import { CreatedTripModel } from '@/features/reservation/types/models/created-trip.model'
import { PaymentDetailsModel } from '@/features/reservation/types/models/payment-details.model'
import { useAskPaymentStrategy } from './ask-payment'
import { usePaypalStrategy } from './paypal-payment'
import { useStripeStrategy } from './stripe-payment'
import { useWalletStrategy } from './wallet-payment'

export type PaymentStrategyProps = {
  createdTrip: CreatedTripModel | null
  paymentDetails: PaymentDetailsModel | null
  isAskForPaymentPending: boolean
  isConfirmPaymentPending: boolean
  onPaymentSuccess: () => void
  onPaymentFail: (error: string) => void
  currency?: string
}

export type PaymentStrategy = (props: PaymentStrategyProps) => {
  Button: React.ReactNode
  Provider: React.FC<{
    children: React.ReactNode
    clientSecret?: string
    currency?: string
  }>
  Form: React.ReactNode | null
}

export const paymentStrategies = {
  ask: useAskPaymentStrategy,
  wallet: useWalletStrategy,
  paypal: usePaypalStrategy,
  stripe: useStripeStrategy,
}

export type StrategyKey = keyof typeof paymentStrategies
